var map = {
	"./1/level-card-banner2.png": "pcHp",
	"./2/level-card-banner2.png": "qlQk",
	"./3/level-card-banner2.png": "Zj9s",
	"./4/level-card-banner2.png": "hqwn",
	"./5/level-card-banner2.png": "9cw7",
	"./6/level-card-banner2.png": "XC/U",
	"./7/level-card-banner2.png": "uACt",
	"./8/level-card-banner2.png": "gKHr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/HBr";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/level\-card\-banner2\.png$
// module id = /HBr
// module chunks = 1